import { render } from "./DelivererSidebar.vue?vue&type=template&id=12b8554c&scoped=true"
import script from "./DelivererSidebar.vue?vue&type=script&lang=js"
export * from "./DelivererSidebar.vue?vue&type=script&lang=js"

import "./DelivererSidebar.vue?vue&type=style&index=0&id=12b8554c&scoped=true&lang=css"
import "./DelivererSidebar.vue?vue&type=style&index=1&id=12b8554c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b8554c"]])

export default __exports__